<app-loading *ngIf="cargando"></app-loading>
<div class="grid simulador-container-general" *ngIf="!cargando">
  <div class="col-12 md:col-7 lg:col-7">
    <div class="simulador-container-principal" >
      <div class="title-container">
        <label class="label-title">{{'SIMULADORCREDITO.LBL_TITULOPRINCIPAL' | translate}}</label>
      </div>
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">
        <div class="grid form-group">
          <!-- Tipo producto -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{'SIMULADORCREDITO.LBL_TIPOPRODUCTO' | translate}}</label>
                <p-dropdown disableTab  id="idTipoProductoBancario" name="TipoProducto" *ngIf="isCredit"
                  [options]="listTiposProductoBancarios" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idTipoProductoBancario"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idTipoProductoBancario.invalid && isCredit">
                  {{ 'SIMULADORCREDITO.LBL_TIPOPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              <label *ngIf="!isCredit" class="falso-combo-texto">{{ nombreCredit }}</label>
            </div>
          </div>
          <!-- Tipo ocupaciones -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_OCUPACIONES' | translate}}</label>
                <p-dropdown disableTab  id="idTipoOcupacionConfiguracion" name="nomTipoOcupacionConfiguracion"
                  [options]="listTiposOcupaciones" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idTipoOcupacionConfiguracion"
                  (onChange)="onChangeOcupacion($event); verificarCampos()"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                  >
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idTipoOcupacionConfiguracion.invalid">
                  {{ 'SIMULADORCREDITO.LBL_OCUPACIONES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Ciudad  -->
          <div class="col-12 md:col-6 lg:col-6" *ngIf="isCiudad">
            <div class="div-form">
              <label>* {{ 'SIMULADORCREDITO.LBL_CIUDAD' | translate }}</label>
              <div>
                <p-autoComplete placeholder="{{ 'LBL_BUSCAR' | translate}}"
                                optionLabel="camino" name="buscar" id="idCiudad"
                                formControlName="ciudad"
                                autocomplete="new-password"
                                [suggestions]="resCiudades"
                                [forceSelection]="true"
                                (completeMethod)="buscar($event)"
                                (onClear)="limpiarCiudad()"
                                (onSelect)="capturarLugar($event); verificarCampos()"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                showEmptyMessage="true"
                >
                </p-autoComplete>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCiudad.invalid">
                  {{ 'SIMULADORCREDITO.LBL_CIUDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- Forma de pago -->
          <div class="col-12 md:col-6 lg:col-6" *ngIf="isFormaPago">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_FORMADEPAGO' | translate}}</label>
                <p-dropdown disableTab  id="idFormaPago" name="nomIdFormaPago"
                  [options]="listTiposFormaPago" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idFormaPago"
                  (onChange)="onChangeFormaPago($event); verificarCampos()"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                  >
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idFormaPago.invalid">
                  {{ 'SIMULADORCREDITO.LBL_FORMADEPAGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Pagaduria -->
          <div class="col-12 md:col-6 lg:col-6" *ngIf="isPagaduria">
            <div class="div-form">
              <label>{{'SIMULADORCREDITO.LBL_PAGADURIA' | translate}}</label>
                <p-dropdown disableTab  id="idTiposPagaduria" name="nomTiposPagaduria"
                  [options]="listTiposPagaduria" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idTiposPagaduria"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idTiposPagaduria.invalid">
                  {{ 'SIMULADORCREDITO.LBL_PAGADURIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Destino -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_DESTINO' | translate}}</label>
                <p-dropdown disableTab  *ngIf="isDestino" id="idDestino" name="nomTiposDestinos" filter="true"
                  [options]="listTiposDestinos" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idDestino"
                  (onChange)="verificarCampos()"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <label *ngIf="!isDestino" class="falso-combo-texto"></label>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idDestino.invalid">
                  {{ 'SIMULADORCREDITO.LBL_DESTINO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Monto -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_MONTO' | translate}}:</label>
              <div>
                <input type="text" pInputText id="monto"
                      name="monto"
                      autocomplete="new-password"
                      formControlName="monto"
                      moneda-reactive [minimo]="0"
                      [maxlength]="18"
                      style="text-align: left"
                      (keydown.enter)="verificarCampos()"
                      appStopTyping
                      (stopTyping)="verificarCampos()"
                      (onChange)="verificarCampos()"
                  >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.monto.invalid">
                  {{ 'SIMULADORCREDITO.LBL_MONTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <!-- Producto -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_PRODUCTO' | translate}}</label>
                <p-dropdown disableTab  id="idProducto" name="nomTiposProductos"
                  [options]="listTiposProductos" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idProducto" *ngIf="isCampoProducto && !productoFalsoCombo"
                  (onChange)="lanzarServicioGeneral()"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idProducto.invalid && isCampoProducto">
                  {{ 'SIMULADORCREDITO.LBL_PRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <label *ngIf="!isCampoProducto" class="falso-combo-texto"></label>
              <label *ngIf="isCampoProducto && !!productoFalsoCombo" class="falso-combo-texto">{{productoFalsoCombo}}</label>
            </div>
          </div>
          <!-- Frecuencia -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_FRECUENCIA' | translate}}</label>
                <p-dropdown disableTab  id="idFrecuenciaProducto" name="nomTiposFrecuencia"
                  [options]="listTiposFrecuencias" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idFrecuenciaProducto" *ngIf="isCamposHabilitados && !frecuenciaFalsoCombo"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idFrecuenciaProducto.invalid && isCamposHabilitados">
                  {{ 'SIMULADORCREDITO.LBL_FRECUENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
                <label *ngIf="isCamposHabilitados && !!frecuenciaFalsoCombo" class="falso-combo-texto">{{frecuenciaFalsoCombo}}</label>
            </div>
          </div>
          <!-- Numero cuotas -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_NUMERODECUOTAS' | translate}}</label>
                <input type="text" pInputText id="idNumeroCuotas" name="nomNumeroCuotas"
                      autocomplete="off" formControlName="numeroCuotas"
                      appTexto [sinCaracteres]="true" [sinComa]="true" numero-decimal-reactive [minimo]="1"
                      [sinEspacio]="true" [sinPunto]="true" [sinLetras]="true" [maxlength]="3" *ngIf="isCamposHabilitados"
                />
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.numeroCuotas.invalid && isCamposHabilitados">
                  {{ 'SIMULADORCREDITO.LBL_NUMERODECUOTAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
            </div>
          </div>
          <!-- Tipo cuotas -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_TIPODECUOTA' | translate}}</label>
                <p-dropdown disableTab  id="idTipoCuota" name="nomTiposdeCuota"
                  [options]="listTiposdeCuotas" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idTipoCuota" *ngIf="isCamposHabilitados && isCampoCuota"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <label *ngIf="!isCampoCuota" class="falso-combo-texto">{{ nombreCuota }}</label>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idTipoCuota.invalid && isCamposHabilitados && isCampoCuota">
                  {{ 'SIMULADORCREDITO.LBL_TIPODECUOTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Tipo tasas producto -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_TIPODETASA' | translate}}</label>
                <p-dropdown disableTab  id="idTipoTasaProducto" name="nomTasasProducto"
                  [options]="listTiposTasasProducto" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idTipoTasaProducto" *ngIf="isCamposHabilitados && isCampoTasa"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <label *ngIf="!isCampoTasa" class="falso-combo-texto">{{ nombreTasa }}</label>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idTipoTasaProducto.invalid && isCamposHabilitados && isCampoTasa">
                  {{ 'SIMULADORCREDITO.LBL_TIPODETASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Fondo de garantias -->
          <div class="col-12 md:col-6 lg:col-6" *ngIf="isFondosGarantias">
            <div class="div-form">
              <label>* {{'SIMULADORCREDITO.LBL_FONDOGARANTIAS' | translate}}</label>
                <p-dropdown disableTab  id="idGarantiaIdonea" name="nomFondosGarantia"
                  [options]="listTiposFondosGarantias" placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                  [autoWidth]="false" formControlName="idGarantiaIdonea" *ngIf="isCamposHabilitados && isCampoGarantia"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label">
                </p-dropdown>
                <label *ngIf="!isCampoGarantia" class="falso-combo-texto">{{ nombreGarantia }}</label>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.idGarantiaIdonea.invalid && isCamposHabilitados && isCampoGarantia">
                  {{ 'SIMULADORCREDITO.LBL_FONDOGARANTIAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
            </div>
          </div>
          <!-- Descuento Tasa -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{'SIMULADORCREDITO.LBL_DESCUENTOTASA' | translate}}</label>
                <input type="text" pInputText id="idDescuentoTasa" name="nomDescuentoTasa"
                  autocomplete="off" formControlName="puntosDescuento" appTexto
                  numero-decimal-reactive [sinComa]="true" [sinEspacio]="true"
                  [decimales]="6" [entero]="3" [sinCaracteres]="true" [sinLetras]="true"
                  appNonZeroInput *ngIf="isCamposHabilitados"
                  (blur)="limpiarOtroCampo('puntosDescuento')" (keydown)="preventEnter($event, 'puntosDescuento')"
                >
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.puntosDescuento.invalid && isCamposHabilitados">
                  {{ 'SIMULADORCREDITO.LBL_DESCUENTOTASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
            </div>
          </div>
          <!-- Tasa especial -->
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{'SIMULADORCREDITO.LBL_TASAESPECIAL' | translate}}</label>
                <input type="text" pInputText id="idTasaEspecial" name="nomTasaEspecial"
                  autocomplete="off" formControlName="tasaEspecial" appTexto
                  numero-decimal-reactive [sinComa]="true" [sinEspacio]="true"
                  [decimales]="6" [entero]="3" [sinCaracteres]="true" [sinLetras]="true"
                  appNonZeroInput *ngIf="isCamposHabilitados"
                  (blur)="limpiarOtroCampo('tasaEspecial')" (keydown)="preventEnter($event, 'tasaEspecial')"
                >
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.tasaEspecial.invalid && isCamposHabilitados">
                  {{ 'SIMULADORCREDITO.LBL_TASAESPECIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <label *ngIf="!isCamposHabilitados" class="falso-combo-texto"></label>
            </div>
          </div>
        </div>
        <!-- Seguro lista -->
        <div class="contenedor-seguros" *ngIf="listSeguros && listSeguros.length > 0">
          <ng-container *ngFor="let seguro of listSeguros">
            <div *ngIf="(seguro && !seguro.valorTasa && seguro.valor) || (seguro && seguro.valorTasa)">
              <div class="descripcion-seguro">
                <div>
                  <label class="label-seguro">{{ seguro && seguro.valorTasa ? seguro.nombre : seguro.nombreSeguro }}<p *ngIf="seguro && !seguro.valorTasa" class="nombre-seguro">{{ seguro.nombre }}</p></label>
                </div>
                <div class="valor-seguro">
                  {{ seguro && seguro.valorTasa ?( seguro.valorTasa + '%' ): ( seguro.valor | dinero: 0 ) }}
                </div>
              </div>
            </div>
          </ng-container>
          <div class="contenedor-total-seguro">
           <div class="total-seguro">
            {{ 'SIMULADORCREDITO.LBL_TOTALSEGUROS' | translate}}
           </div>
           <div class="valor-total-seguros">
            {{ valorTotalSeguros | dinero: 0 }}
           </div>
          </div>
        </div>
        <div class="contenedor-seguros" *ngIf="listSeguros && listSeguros.length == 0 && isNoSeguros">
          <div class="despues-descuentos" style="padding: 10px;">{{'SIMULADORCREDITO.LBL_NOHAYSEGUROS' | translate}}</div>
        </div>
        <!-- Botones -->
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando" class="buttons-simulador-container">
              <button class="button-simular-limpiar" type="button"
                  (click)="limpiarFormulario()">
                  <img src="../../../../../../assets/icons/simulador-credito/ico-limpiar.svg" alt="calculadora">
                  {{'SIMULADORCREDITO.BTN_LIMPIAR' | translate }}
              </button>
              <button icon="fa fa-calculator" label="{{'SIMULADORCREDITO.BTN_SIMULAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
              <span>{{ "LBL_GUARDANDO" | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-12 md:col-5 lg:col-5" style="padding: 0;">
    <div class="simulador-container-resultado" >
      <div class="title-container">
        <label class="label-title">{{'SIMULADORCREDITO.LBL_TITULORESULTADO' | translate}}</label>
      </div>
      <div class="animacion-container" *ngIf="!isResultadoSimulacion">
        <img id="imgUser" src="../../../../assets/animaciones/simulador-credito/animacion-simulador-de-credito.gif" alt="animacion-simulador" />
      </div>
      <div *ngIf="isResultadoSimulacion">
        <div class="contenedor-vouncher-encabezado"></div>
        <div class="contenedor-vouncher-body">
          <div class="contenedor-title-resultado">
            <img id="imgUser" src="../../../../assets/icons/simulador-credito/signo-dolar.svg" alt="signo-dolar" />
            <label class="label-title-resultado">{{'SIMULADORCREDITO.LBL_VALORSOLICITADO' | translate}}</label>
            <strong>{{ resultadoSimulacion.monto | dinero: 0 }}</strong>
          </div>
          <div class="grid container-simulador-resumen">
            <div class="col-12 md:col-3 lg:col-3 label-resumen">
              <div class="col-12">{{'SIMULADORCREDITO.LBL_CUOTAS' | translate}}</div>
              <div class="col-12"><strong>{{ resultadoSimulacion.numeroCuotas }}</strong></div>
            </div>
            <div class="col-12 md:col-3 lg:col-3 label-resumen">
              <div class="col-12">{{'SIMULADORCREDITO.LBL_FRECUENCIA' | translate}}</div>
              <div class="col-12"><strong>{{ resultadoSimulacion.frecuencia }}</strong></div>
            </div>
            <div class="col-12 md:col-3 lg:col-3 label-resumen">
              <div class="col-12">{{ resultadoSimulacion.tipoCuota }}</div>
              <div class="col-12"><strong>{{ resultadoSimulacion.tipoTasaProducto }}</strong></div>
            </div>
            <div class="col-12 md:col-3 lg:col-3 label-resumen">
              <div class="col-12">{{'SIMULADORCREDITO.LBL_SEGUROVOLUNTARIO' | translate}}</div>
              <div class="col-12"><strong>{{ resultadoSimulacion.seguroVoluntario | dinero: 0 }}</strong></div>
            </div>
          </div>
          <div *ngFor="let item of resultadoSimulacion.calculos">
            <div class="separador-simulador">
              <div class="label-separador">{{ item.ordenTasa }}</div>
              <div class="valor-separador">{{ item.cuota | dinero: 0 }}</div>
            </div>
            <div class="grid contenedor-tasas-interes">
              <div class="col-12 md:col-6 lg:col-6 tasas-interes">
                <div>{{'SIMULADORCREDITO.LBL_TASAEA' | translate}}</div>
                <div><strong>{{ item.tasa | number:'2.2-2' }}%</strong></div>
              </div>
              <div class="col-12 md:col-6 lg:col-6 tasas-interes">
                <div>{{'SIMULADORCREDITO.LBL_TASAPERIODICA' | translate}}</div>
                <div><strong>{{ ( item.tasaPeriodica * 100 ) | numero:4 }}%</strong></div>
              </div>
            </div>
            <div (click)="toggleAccordionOtrosCargos(item)" class="contenedor-descuentos">
              <div class="acordion-header">
                  <div class="label-acordeon">
                    <i [ngClass]="{ 'fa-chevron-right': !item.isExpandedOtrosCargos, 'fa-chevron-down': item.isExpandedOtrosCargos }" class="fa"></i>
                      <span>{{'SIMULADORCREDITO.LBL_OTROSCARGOS' | translate}}</span>
                  </div>
                  <div class="valor-acordeon">
                      <span>{{ item.valorTotalOtrosCargos | dinero: 0 }}</span>
                  </div>
              </div>
              <div *ngIf="item.isExpandedOtrosCargos">
                <ng-container *ngIf="item.otrosCargos && item.otrosCargos.length > 0">
                  <ng-container *ngFor="let otrosCargo of item.otrosCargos">
                    <div class="acordion-descuentos">
                        <span>{{ otrosCargo.nombre }}</span>
                        <label>{{ otrosCargo.valor | dinero: 0 }}</label>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!item.otrosCargos || item.otrosCargos.length == 0">
                  <div class="despues-descuentos sin-descuentos">{{'SIMULADORCREDITO.LBL_SINOTROSCARGOS' | translate}}</div>
                </ng-container>
              </div>
            </div>
            <div (click)="toggleAccordion(item)" class="contenedor-descuentos">
                <div class="acordion-header">
                    <div class="label-acordeon">
                      <i [ngClass]="{ 'fa-chevron-right': !item.isExpanded, 'fa-chevron-down': item.isExpanded }" class="fa"></i>
                        <span>{{'SIMULADORCREDITO.LBL_TOTALDESCUENTOS' | translate}}</span>
                    </div>
                    <div class="valor-acordeon">
                        <span>{{ item.valorTotalDescuentos | dinero: 0 }}</span>
                    </div>
                </div>
                <div *ngIf="item.isExpanded">
                  <ng-container *ngIf="item.descuentos && item.descuentos.length > 0">
                    <ng-container *ngFor="let descuento of item.descuentos">
                      <div class="acordion-descuentos">
                          <span>{{ descuento.nombre }}</span>
                          <label>{{ descuento.valor | dinero: 0 }}</label>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!item.descuentos || item.descuentos.length == 0">
                    <div class="despues-descuentos sin-descuentos">{{'SIMULADORCREDITO.LBL_SINDESCUENTOS' | translate}}</div>
                  </ng-container>
                </div>
            </div>
            <div class="valor-cuota">
                <p>{{'SIMULADORCREDITO.LBL_VALORADESEMBOLSAR' | translate}}</p>
                <span>{{ item.valorNeto | dinero: 0 }}</span>
            </div>
            <div class="despues-descuentos" style="margin-bottom: 10px;">{{'SIMULADORCREDITO.LBL_DESPUESDEDESCUENTOS' | translate}}</div>
          </div>
          <!-- Botones -->
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando" class="buttons-simulador-container">
                <button icon="fa fa-calculator" label="{{'SIMULADORCREDITO.LBL_CREARSOLICITUD' | translate }}"
                        (click)="crearSolicitud()"
                        type="button"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
                <span>{{ "LBL_GUARDANDO" | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="contenedor-vouncher-footer"></div>
      </div>
    </div>
  </div>
</div>
